export const ClaimStatuses = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETE: 'COMPLETE',
  EXPIRED: 'EXPIRED',
} as const;

export type ClaimStatus = (typeof ClaimStatuses)[keyof typeof ClaimStatuses];
